import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { APIURLConstantsService } from '../services/api-url-service/apiurlconstants.service';

import { IFRConcursos } from './concursos.interfaces';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ListConcursosService {
  public valFiltres: IFRConcursos = {'offset': null, 
  'registers': null, 
  'rows': [{
    clau: null,
    titol: null,
    data_limit_presentacio: null,
    data_publicacio: null,
    estat: null,
    estat_projecte: null,
    ambit: null,
    empresa: null,
    ciutat: null,
    pais: null,
    tematiques: null,
    grup_tematiques: null,
    any_signatura: null,
    any_ult_factura: null,
    data_signatura: null,
    data_ult_factura: null,
    pproj: null,
    ppropi: null,
    certificat: null,
    cpv: null,
    client: null
    }]
  };
  public currentPage: number = 0;
  public rowsPerPage: number = 20;
  public tematiques_grup: {value: string, text: string}[] = null;

  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id)
    .pipe(map(response => { return response || []; }));
  }

  constructor(protected authHttp: HttpClient) { }
}
